// exclude-from-index
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText, Input } from '@mui/material';
import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';
import { muiGlobalTheme } from '@themes';
import { cloneDeep } from 'lodash';
import { colors } from '../../css';

const customizeMuiGlobalTheme = () => {
  const newInputTheme = cloneDeep(muiGlobalTheme);
  newInputTheme.palette.text.primary = '#000';
  newInputTheme.palette.text.secondary = colors.colorGrey03;
  newInputTheme.components.MuiListItemText = {
    styleOverrides: { primary: { color: colors.colorBlack } }
  };

  newInputTheme.components.MuiSelect = {
    styleOverrides: { variant: 'standard' }
  };

  return createTheme(newInputTheme);
};

function MultipleSelect(props) {
  const { value, values, handleValueChange, disabled, ...defaultProps } = props;
  const { InputProps } = defaultProps;

  const inputTheme = useRef(customizeMuiGlobalTheme());

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={inputTheme.current}>
        <FormControl className="roomSelection">
          <InputLabel variant="standard" htmlFor="select-multiple-checkbox">
            Select Room Types
          </InputLabel>
          <Select
            multiple
            value={value}
            variant="outlined"
            onChange={handleValueChange}
            input={<Input id="select-multiple-checkbox" {...InputProps} />}
            renderValue={(select) => select.join(', ')}
            disabled={disabled}
          >
            {values.map((item) => (
              <MenuItem key={item.value} value={item.value}>
                <Checkbox checked={value.indexOf(item.value) > -1} />
                <ListItemText primary={item.label} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

MultipleSelect.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  values: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    })
  ),
  handleValueChange: PropTypes.func,
  disabled: PropTypes.bool
};

MultipleSelect.defaultProps = {
  value: [],
  values: [],
  handleValueChange: PropTypes.func,
  disabled: false
};

export default MultipleSelect;
